import React from 'react';
import { Divider, Typography, Stack } from '@worthy-npm/worthy-common-ui-components';

export default function TrustSection() {
  return (
    <Stack gap={2} justifyContent="center" alignItems="center">
      <Divider variant="fullWidth" orientation="horizontal" sx={{ width: '100%' }} />
      <Typography variant="caption" color="primary" fontWeight="light">
        **Insurance and fees covered
      </Typography>
      <Stack direction="row" width="100%" alignItems="center" justifyContent="space-around">
        <img src="/images/trustIcons/Fedex.svg" alt="FedEx" height={30} />
        <img src="/images/trustIcons/lloyds.svg" alt="Lloyd's" height={20} />
        <img src="/images/trustIcons/GIA_logo.png" alt="GIA" height={30} />
      </Stack>
    </Stack>
  );
}
